// Sync the compare-styles promo card's height to exactly 2 sibling product
// cards on desktop. CSS can't do this on its own because the product card's
// rendered height isn't a clean ratio of its column width (depends on title
// wrap + font metrics), so an aspect-ratio guess will drift as the viewport
// changes. Measure a real product card and apply the result.

(function () {
  var DESKTOP_MIN = 750;

  function syncPromoHeights() {
    var promos = document.querySelectorAll('.grid__item--compare-promo');
    if (!promos.length) return;

    promos.forEach(function (promo) {
      // Clear any prior inline height before re-measuring so the sibling
      // product card's natural height isn't influenced by an old value.
      promo.style.height = '';

      if (window.innerWidth < DESKTOP_MIN) return;

      var grid = promo.parentElement;
      if (!grid) return;

      var sibling = grid.querySelector(
        '.grid__item:not(.grid__item--compare-promo):not(.grid__item--big-card)'
      );
      if (!sibling) return;

      var rowGap = parseFloat(getComputedStyle(grid).rowGap) || 0;
      var siblingHeight = sibling.getBoundingClientRect().height;
      if (!siblingHeight) return;

      promo.style.height = (siblingHeight * 2 + rowGap) + 'px';
    });
  }

  // Debounce resize so we don't thrash on drag.
  var resizeTimer = null;
  function onResize() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncPromoHeights, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPromoHeights);
  } else {
    syncPromoHeights();
  }

  // Re-measure after fonts settle, in case heading text reflows.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncPromoHeights);
  }

  window.addEventListener('resize', onResize);
})();
